export enum EUserType {
  CITIZEN = 'CITIZEN',
  CLIENT = 'CLIENT'
}
